import moment from 'moment'

let customTime = value => {
  return moment(value).format('YYYY-MM-DD,HH:mm:ss')
}

let formatThousand = value => {
  let num = Number(value)
  if (isNaN(num)) {
    return '--'
  } else {
    return (value / 1000).toFixed(2)
  }
}
export {
  customTime,
  formatThousand
}
